import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Supplier } from "../models/Supplier";

export const getSuppliers = async (
	params: { includeInactive?: boolean } = {},
	signal?: AbortSignal,
): Promise<Supplier[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "IncludeInactive", value: params.includeInactive || false },
	];

	const resp = await apiService.callV2(
		"[SUP].[GetSuppliers]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Supplier[];
	} else {
		throw new Error(resp.message || "Error fetching suppliers");
	}
};
